import { render, staticRenderFns } from "./DeleteBrickPrompt.vue?vue&type=template&id=3b139002&"
import script from "./DeleteBrickPrompt.vue?vue&type=script&lang=js&"
export * from "./DeleteBrickPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b139002')) {
      api.createRecord('3b139002', component.options)
    } else {
      api.reload('3b139002', component.options)
    }
    module.hot.accept("./DeleteBrickPrompt.vue?vue&type=template&id=3b139002&", function () {
      api.rerender('3b139002', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/DeleteBrickPrompt.vue"
export default component.exports